interface HasId {
  id: number
}

export const idEquals = (id: number) => (hasId: HasId) => id === hasId.id

export interface HasName {
  name: string
}

interface HasUrl {
  url: string
}

export const selectUrl = <T extends HasUrl>(hasUrl: T) => hasUrl.url
